import { stepUpdated } from '../../../../redux/questionnaire/questionnaire.slice';
import { updatePreviousQuestion } from '../../../../redux/questionnaire/thunks';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import { clearFormError } from '../../../../redux/ui/ui.slice';
import { ButtonType } from '../../../../redux/ui/typings';
import { t } from '../../../../strings/i18n/i18n';
import { DisputeFeature } from '../../../../typings';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
import { RECURRING_TABLE_LIST_QUESTION_ID } from '../../../../const/questionIds';
import { closeModalHelper } from './closeHandlers';
import { errorButtonHandler, errorButtonText } from './errorHandlers';
export var determineSecondaryButtonTitleAndText = function (step, error, isRedispute, lowBalanceDisputeApplied, currentQuestionId) {
    switch (step) {
        case QuestionnaireFlow.Start: {
            if (isRedispute) {
                return {
                    secondaryText: "".concat(t('button.noGoBack')),
                    secondaryDataType: Analytics.Redispute,
                    secondaryDataReason: 'no go back'
                };
            }
            return {
                secondaryText: "".concat(t('button.cancel')),
                secondaryDataType: 'cancel'
            };
        }
        case QuestionnaireFlow.CreditDetails:
            return {
                secondaryText: t('button.yesContinueDispute'),
                secondaryDataType: 'yes continue to dispute'
            };
        case QuestionnaireFlow.RedisputeReview:
            return {
                secondaryDataReason: 'Previous step',
                secondaryDataType: Analytics.Redispute,
                secondaryText: t('button.previousQuestion')
            };
        case QuestionnaireFlow.RecognizeCharge:
        case QuestionnaireFlow.InProgress:
        case QuestionnaireFlow.Review:
            return {
                secondaryDataReason: 'Previous step',
                secondaryDataTitle: Analytics.DisputeTransaction,
                secondaryDataType: currentQuestionId === RECURRING_TABLE_LIST_QUESTION_ID
                    ? Analytics.RecurringTransactions
                    : Analytics.DisputeTransaction,
                secondaryText: "".concat(t('button.previousQuestion'))
            };
        case QuestionnaireFlow.ContactFraud:
            return {
                secondaryDataReason: 'Back',
                secondaryDataTitle: Analytics.DisputeTransaction,
                secondaryDataType: Analytics.DisputeTransaction,
                secondaryText: "".concat(t('button.back'))
            };
        case QuestionnaireFlow.BusinessError: {
            var _a = errorButtonText(ButtonType.Secondary, error), text = _a.text, dataReason = _a.dataReason;
            return {
                secondaryDataReason: dataReason,
                secondaryDataTitle: Analytics.DisputeTransaction,
                secondaryDataType: Analytics.DisputeTransaction,
                secondaryText: text
            };
        }
        case QuestionnaireFlow.CancelQuestionnaire:
            return {
                secondaryDataReason: 'No-do-not-cancel',
                secondaryDataTitle: Analytics.DisputeTransaction,
                secondaryDataType: Analytics.DisputeTransaction,
                secondaryText: "".concat(t('button.dontCancel'))
            };
        case QuestionnaireFlow.End:
            if (lowBalanceDisputeApplied) {
                return {
                    secondaryDataReason: '',
                    secondaryText: '',
                    secondaryDataTitle: '',
                    secondaryDataType: ''
                };
            }
            return {
                secondaryDataReason: 'Done',
                secondaryDataTitle: Analytics.DisputeTransaction,
                secondaryDataType: Analytics.DisputeTransaction,
                secondaryText: "".concat(t('button.secureMessaging'))
            };
        default:
            return {
                secondaryDataReason: '',
                secondaryText: '',
                secondaryDataTitle: '',
                secondaryDataType: ''
            };
    }
};
export var determineSecondaryButtonHandler = function (step, callback) {
    return function (dispatch, getState) {
        dispatch(clearFormError());
        var _a = getState(), _b = _a.questionnaire, previousStep = _b.previousStep, source = _b.businessError.source, postCasesCount = _a.caseDetails.postCasesCount, parentSecureMessage = _a.appConfig.parentSecureMessage;
        var errorData = {
            source: source,
            count: postCasesCount
        };
        switch (step) {
            case QuestionnaireFlow.Start:
                dispatch(closeModalHelper());
                break;
            case QuestionnaireFlow.CreditDetails:
                dispatch(stepUpdated(QuestionnaireFlow.InProgress));
                break;
            case QuestionnaireFlow.InProgress:
            case QuestionnaireFlow.ContactFraud:
            case QuestionnaireFlow.RedisputeReview:
            case QuestionnaireFlow.Review:
                dispatch(updatePreviousQuestion());
                break;
            case QuestionnaireFlow.BusinessError:
                dispatch(errorButtonHandler(ButtonType.Secondary, errorData));
                break;
            case QuestionnaireFlow.CancelQuestionnaire:
                dispatch(stepUpdated(previousStep));
                break;
            case QuestionnaireFlow.End:
                if (callback)
                    callback();
                parentSecureMessage();
                dispatch(closeModalHelper(DisputeFeature.DisputeCenter));
                break;
            default:
                break;
        }
    };
};
export var determineSecondaryButtonType = function (step, lowBalanceDisputeApplied) {
    if (step === QuestionnaireFlow.End && !lowBalanceDisputeApplied) {
        return ButtonType.Secondary;
    }
    return ButtonType.Ghost;
};
//# sourceMappingURL=secondaryHandlers.js.map